export enum UsersGroupsContext {
  Users = "Users",
  Groups = "Groups",
  TemplateGroups = "Template",
}
